import { Box, Paper, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { styled } from "@mui/material/styles";
import { Status } from "components/common";
import { formatDistanceToNow } from "date-fns";

const TextMeta = styled(Typography)`
  && {
    font-weight: bold;
    align-self: center;
  }
`

const TextItem = styled(Typography)`
  && {
    align-self: center;
  }
`

function formatDistanceDay(date) {
  if (!date) {
    return 'None';
  }
  return formatDistanceToNow(date, { addSuffix: true })
    .replace('about ', '')
    .replace('less than a', '1')
    .replace('minutes', 'mins');
}


function AlertCard({ alert, onClick = () => {} }) {
  // console.log(alert);
  const { position, displayName, id, priority, text, occuredAt } = alert;
  const occurredAtAgo = formatDistanceDay(occuredAt);

  
  return (
    <Box sx={{ margin: "5px" }}>
      <Paper sx={{ p: 2, m: "auto" }} onClick={() => onClick(alert)}>
        <Grid container spacing={2}>
          <Grid item>
            <TextMeta style={{ fontSize: "30px" }}>{displayName}</TextMeta>
          </Grid>
        </Grid>
        {/* <Grid container spacing={2}>
          <Grid item>
            <TextMeta>Alert ID:</TextMeta>
          </Grid>
          <Grid item>
            <TextItem>{id}</TextItem>
          </Grid>
        </Grid> */}
        <Grid container spacing={2}>
          <Grid item>
            <TextMeta>Priority:</TextMeta>
            {priority ? <Status status={priority} /> : "Unknown"}
          </Grid>
        </Grid>
        {/* {position ? (
          <Grid container spacing={2}>
            <Grid item>
              <TextMeta>Incident Location:</TextMeta>
              <TextItem> {position.lat}, {position.lon} </TextItem>
            </Grid>
          </Grid>
        ) : (
          <React.Fragment />
        )} */}
        <Grid container spacing={2}>
          <Grid item>
            <TextMeta>Incident Time:</TextMeta>
            <TextItem>{occuredAt ? new Date(occuredAt).toLocaleString() : "Unknown"}</TextItem>
            <TextItem>({occurredAtAgo})</TextItem>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item>
            <TextMeta>Description:</TextMeta>
            <TextItem>{text}</TextItem>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}

export { AlertCard };
